<template>
  <div v-if="!dialIsCalling">
    <v-text-field
      v-model="dialPhoneNumber"
      label="Phone number"
      dense
      rounded
      singleLine
      hide-details
      append-outer-icon="mdi-backspace"
      @click:append-outer="backspace"
      v-on:keydown.enter.exact.prevent
      v-on:keydown.enter.exact="onEnter"
      v-on:input="onTyping"
      class="search-input font-weight-bold"
    ></v-text-field>
  </div>
  <div v-else>
    <v-text-field
      v-model="dialDtmf"
      dense
      rounded
      readonly
      singleLine
      hide-details
      class="search-input font-weight-bold"
      append-outer-icon="mdi-backspace"
      @click:append-outer="backspace"
    ></v-text-field>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DialNumber',
  computed: {
    ...mapGetters('call', ['dialIsCalling', 'dialPhoneNumber', 'dialDtmf'])
  },
  methods: {
    ...mapActions('call', [
      'delNumPad',
      'setDialTo',
      'setDialPhoneNumber',
      'setDialIsCalling',
      'setDialIsOpenPanel',
      'clearDialIsShowNumPads'
    ]),
    onEnter(value) {
      this.setDialTo(this.dialPhoneNumber)
      this.setDialPhoneNumber(this.dialPhoneNumber)
      this.setDialIsCalling(true)
      this.setDialIsOpenPanel(true)
      this.clearDialIsShowNumPads()
    },
    onTyping(value) {
      this.setDialPhoneNumber(value)
    },
    backspace() {
      this.delNumPad()
      this.$emit('dtmf', null)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__icon {
  padding-top: 8px;
  padding-right: 18px;
}
::v-deep .v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  margin-left: 30px;
  text-align: center;
  color: $text-color;
}
</style>
